import BCMS, { Route } from "@bcm-dev/bcms-vite";
import "content-styles.css";
import "res/css/shared-styles.css";

// fonts
import "./res/fonts/NunitoSans-Regular.woff2";
import "./res/fonts/NunitoSans-Semibold.woff2";

// compid pages
import Activity from "compid/pages/ActivityPage";
import AddNonManagedBiller from "compid/pages/AddBillerPage";
import AddCompany from "compid/pages/AddBillerPage/components/AddCompany";
import AddPerson from "compid/pages/AddBillerPage/components/AddPerson";
import AddManageBiller from "compid/pages/AddManageBillerPage";
import BillerDetails, { BillerActivityWidget, BillerDetailsWidget } from "compid/pages/BillerDetailsPage";
import ConfirmAutoPayDetails from "compid/pages/ConfirmAutoPay";
import MultipayConfirmationPage from "compid/pages/MultipayConfirmationPage";
import PayBills from "compid/pages/PayBillsPage";
import PaymentConfirmation from "compid/pages/PaymentConfirmationPage";
import RequestEBillPage from "compid/pages/RequestEBillPage";
import ReviewAndPay from "compid/pages/ReviewAndPayPage";
import SearchBiller from "compid/pages/SearchBillerPage";

import AddAutoPayPage from "compid/pages/AddAutoPay";
import ConfirmAutoPayPage from "compid/pages/ConfirmAutoPay";
import ConfirmEBillPage from "compid/pages/ConfirmEBillPage";

import AddAutopayWorkflow from "compid/workflows/AddAutoPay";
import AddBillerWorkflow from "compid/workflows/AddBiller";
import AddBillerLongWorkflow from "compid/workflows/AddBillerLong";
import BillDiscoveryWorkflow from "compid/workflows/BillDiscoveryWorkflow";
import EditBillerWorkflow from "compid/workflows/EditBillerWorkflow";
import EditPaymentWorkflow from "compid/workflows/EditPaymentWorkflow";
import MakeAPaymentWorkflow from "compid/workflows/MakeAPayment";
import MultiPayWorkflow from "compid/workflows/MultiPay";
import PaymentInquiryWorkflow from "compid/workflows/PaymentInquiryWorkflow";
import ReminderWorkflow from "compid/workflows/ReminderWorkflow";
import RequestEBillWorkflow from "compid/workflows/RequestEBill";
import ViewBillWorkflow from "compid/workflows/ViewBillWorkflow";

import FindMyBills from "compid/pages/FindMyBillsPage";
import FirstTimeUserWelcomePage from "compid/pages/FirstTimeUserWelcomePage";
import SearchResults from "compid/pages/SearchResultsPage";

import SchedulePaymentsPage from "compid/pages/SchedulePaymentsPage";

import EditBillerDetailsPage from "compid/pages/EditBillerDetailsPage";
import EditPaymentPage from "compid/pages/EditPaymentPage";
import MobileWrapper from "compid/pages/MobileWrapper";
import PageNotFound from "compid/pages/PageNotFound";
import ViewPaymentPage from "compid/pages/ViewPaymentPage";

import CanceledEBillPage from "compid/pages/CanceledEBillPage";
import TurnOffEBillPage from "compid/pages/TurnOffEBillPage";

import AddReminderPage from "compid/pages/AddReminderPage";
import ReminderConfirmationPage from "compid/pages/ReminderConfirmationPage";

import PaymentInquiryConfirmationPage from "compid/pages/PaymentInquiryConfirmationPage";
import PaymentInquiryPage from "compid/pages/PaymentInquiryPage";

import BillerGroupsPage from "compid/pages/BillerGroupsPage";
import BillerGroupsWorkflow from "compid/workflows/BillerGroupsWorkflow";

import AddAddressForOvernightDeliveryPage from "compid/pages/AddAddressForOvernightDeliveryPage";
import EditAutopayPage from "compid/pages/EditAutopayPage";
import InitalLoadPage from "compid/pages/InitialLoadPage";
import ViewBillPage from "compid/pages/ViewBillPage";
import ZellePage from "compid/pages/ZellePage";
import IntegrationContainer from "compid/shared/containers/IntegrationContainer";
import MobileIntegrationContainer from "compid/shared/containers/MobileIntegrationContainer";

function App() {
  return (
    <BCMS env={ import.meta.env } customCSS="custom_css_rxp22">
      {/* compid pages */}
      <Route path="/" element={ <InitalLoadPage /> } />
      <Route path="/activity" element={ <Activity/> } />
      <Route path="/activity/:billerID" element={ <Activity/> } />
      <Route path="/addManageBiller" element={ <AddManageBiller/> } />
      <Route path="/searchBiller" element={ <SearchBiller/> } />
      <Route path="/billerDetails" element={ <BillerDetails/> }>
        <Route path="/billerDetails/activity/:id" element={ <BillerActivityWidget/> } /> 
        <Route path="/billerDetails/details/:id" element={ <BillerDetailsWidget/> } /> 
      </Route>

      <Route path="/editBillerDetails" element={ <EditBillerDetailsPage/> } />
      <Route path="/editBillerWorkflow" element={ <EditBillerWorkflow /> } />
      <Route path="/editBillerWorkflow/:billerID" element={ <EditBillerWorkflow /> } />
        
      <Route path="/billerDetails/:id" element={ <BillerDetails/> } />
      <Route path="/reviewAndPay" element={ <ReviewAndPay/> } />
      <Route path="/paymentConfirmation" element={ <PaymentConfirmation/> } />

      <Route path="/addBiller" element={ <AddNonManagedBiller/> }>
        <Route path="addCompany" element={ <AddCompany/> } /> 
        <Route path="addPerson" element={ <AddPerson/> } /> 
      </Route>

      <Route path="/paybills" element={ <PayBills /> } />

      <Route path="/requestEbill" element={ <RequestEBillPage/> } />
      <Route path="/confirmEbill" element={ <ConfirmEBillPage/> } />
      <Route path="/confirmautopaydetails" element={ <ConfirmAutoPayDetails/> } />
      <Route path="/turnOffEBill" element={ <TurnOffEBillPage/> } />
      <Route path="/turnOffEBill/:billerID" element={ <TurnOffEBillPage /> } />
      <Route path="/canceledEBill" element={ <CanceledEBillPage/> } />
          
      <Route path="/requestEBillWorkflow" element={ <RequestEBillWorkflow /> } />
      <Route path="/requestEBillWorkflow/:billerID" element={ <RequestEBillWorkflow /> } />
      <Route path="/requestEBillWorkflow/:billerID/:stepID" element={ <RequestEBillWorkflow /> } />
      
   
      <Route path="/addBillerWorkflow" element={ <AddBillerWorkflow /> } />
      <Route path="/addBillerWorkflow/:stepID" element={ <AddBillerWorkflow /> } />
      <Route path="/addBillerWorkflow/:billerID/:stepID" element={ <AddBillerWorkflow /> } />

      <Route path="/addBillerLongWorkflow" element={ <AddBillerLongWorkflow /> } >
        <Route path="addCompany" element={ <AddCompany /> } />
        <Route path="addPerson" element={ <AddPerson /> } />
      </Route>

      <Route path="/addAutopay" element={<AddAutoPayPage/>} />
      <Route path="/confirmAutopay" element={ <ConfirmAutoPayPage/> } />
      <Route path="/addAutopayWorkflow" element={ <AddAutopayWorkflow /> } />
      <Route path="/addAutopayWorkflow/:billerID" element={ <AddAutopayWorkflow /> } />
      <Route path="/addAutopayWorkflow/:billerID/:stepID" element={ <AddAutopayWorkflow /> } />
      <Route path="/addAutopayWorkflow/:billerID/:stepID/:autopayID" element={ <AddAutopayWorkflow /> } />
      <Route path="/editAutopay" element={ <EditAutopayPage /> } />
      <Route path="/editAutopay/:billerID" element={ <EditAutopayPage /> } />
      
      <Route path ="/makeAPayment" element= {<MakeAPaymentWorkflow />} />
      <Route path ="/makeAPayment/:billID" element= {<MakeAPaymentWorkflow />} />
      <Route path="/makeAPayment/:billID/:stepID" element={ <MakeAPaymentWorkflow /> } />
      <Route path="/viewPayment/" element={ <ViewPaymentPage /> } />
      <Route path="/viewPayment/:paymentID" element={ <ViewPaymentPage /> } />

      <Route path="/editPayment" element={ <EditPaymentPage /> } />
      <Route path="/editPayment/:id" element={ <EditPaymentPage /> } />
      <Route path="/editPaymentWorkflow/:paymentID" element={ <EditPaymentWorkflow /> } />
      <Route path="/editPaymentWorkflow/:paymentID/:stepID" element={ <EditPaymentWorkflow /> } />

      <Route path="/Welcome" element={ <FirstTimeUserWelcomePage /> } />
      <Route path="/FindMyBills" element={ <FindMyBills /> } />
      <Route path="/SearchResults" element={ <SearchResults />} />
      <Route path="/billDiscoveryWorkflow" element={ <BillDiscoveryWorkflow /> } />
      <Route path="/billDiscoveryWorkflow/:stepID" element={ <BillDiscoveryWorkflow /> } />

      <Route path="/schedulePayment" element={ <SchedulePaymentsPage /> } />
      <Route path="/multipayConfirmationPage" element={ <MultipayConfirmationPage /> } />
      <Route path="/multiPayWorkflow" element={ <MultiPayWorkflow /> } />
      <Route path="/multiPayWorkflow/:billIDs" element={ <MultiPayWorkflow /> } />
      <Route path="/multiPayWorkflow/:billIDs/:stepID" element={ <MultiPayWorkflow /> } />

      {/* confirmation will need reworked for workflow component */}
      <Route path="/addReminder" element={ <AddReminderPage /> } />
      <Route path="/addReminderWorkflow" element={ <ReminderWorkflow /> } />
      <Route path="/addReminderWorkflow/:billerID" element={ <ReminderWorkflow /> } />
      <Route path="/addReminderWorkflow/:billerID/:stepID" element={ <ReminderConfirmationPage /> } />
      <Route path="/addReminderConfirmation" element={ <ReminderConfirmationPage /> } />
      <Route path="/addReminderConfirmation/:billerID" element={ <ReminderConfirmationPage /> } />
      <Route path="/addReminderConfirmation/:billerID/:stepID" element={ <ReminderConfirmationPage /> } />

      {/* confirmation will need reworked for workflow component */}
      <Route path="/paymentInquiry" element={ <PaymentInquiryPage /> } />
      <Route path="/paymentInquiryWorkflow" element={ <PaymentInquiryWorkflow /> } />
      <Route path="/paymentInquiryWorkflow/:paymentID" element={ <PaymentInquiryWorkflow /> } />
      <Route path="/paymentInquiryWorkflow/:paymentID/:stepID" element={ <PaymentInquiryWorkflow /> } />
      <Route path="/paymentInquiryConfirmation" element={ <PaymentInquiryConfirmationPage /> } />

      <Route path="/billerGroups" element={ <BillerGroupsPage /> } />
      <Route path="/billerGroupsWorkflow" element={ <BillerGroupsWorkflow /> } />

      <Route path="/viewBill" element={ <ViewBillPage /> } />
      <Route path="/viewBill/:billID" element={ <ViewBillPage /> } />
      <Route path="/viewBillWorkflow" element={ <ViewBillWorkflow /> } />
      <Route path="/viewBillWorkflow/:billID" element={ <ViewBillWorkflow /> } />
      <Route path="zelle" element={ <ZellePage /> } />
      <Route path="*" element={ <PageNotFound /> } />
      <Route path="/MobileWrapper" element={ <MobileWrapper/> } />
      <Route path="/capture/*" element={<IntegrationContainer/>}/>
      <Route path="/MobileCapture/*" element={<MobileIntegrationContainer/>}/>

      <Route path="/addAddressForOvernightDelivery" element={ <AddAddressForOvernightDeliveryPage /> } />
    </BCMS>

  );
}

export default App;